import { render, staticRenderFns } from "./MSuratEdaran.vue?vue&type=template&id=f29bb7da&"
import script from "./MSuratEdaran.vue?vue&type=script&lang=js&"
export * from "./MSuratEdaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports